import AppHelper from '@/helpers/app_helper';

export default class ChecklistHelper {
  static checklistGroupedBySection(checklist, itemIdentifiersToInclude) {
    const shouldIncludeAllItems = itemIdentifiersToInclude === undefined;

    const checklistGroupedBySection = {};
    for (const itemIdentifier in checklist.items) {
      if (
        shouldIncludeAllItems ||
        itemIdentifiersToInclude.includes(itemIdentifier)
      ) {
        const item = checklist.items[itemIdentifier];

        if (checklistGroupedBySection[item.section] === undefined)
          checklistGroupedBySection[item.section] = [];

        checklistGroupedBySection[item.section].push({
          text: item.text,
          value: itemIdentifier,
          help: item.help,
          measurement: item['measurement'],
          order: item.order,
        });
      }
    }

    const checklistGroupedBySectionOrdered = {};
    const sections = AppHelper.alphabeticallySortedArrayFromObj(
      checklistGroupedBySection
    );
    sections.forEach((section) => {
      checklistGroupedBySectionOrdered[section] = checklistGroupedBySection[
        section
      ].sort((a, b) => a.order - b.order);
    });

    return checklistGroupedBySectionOrdered;
  }

  static checklistSections(checklistItems) {
    const sections = {};
    for (const clItemId in checklistItems) {
      const item = checklistItems[clItemId];
      item.clId = clItemId;

      sections[item.section] ||= [];
      sections[item.section].push(item);
    }

    Object.values(sections).forEach((unsortedItems) => {
      unsortedItems.sort((a, b) => a.order - b.order);
    });

    return sections;
  }
}
